import { DuplicatePath, TrashPath } from "./blockChrome";

// Tier-3 builder presentation seam (Phase 4, mechanical extraction).
//
// The Multi-Week builder's weekday edit toolbar. Every gate
// (canMoveSelectedPrevious / canMoveSelectedNext / canDuplicateSelectedWorkout /
// canDeleteSelectedWorkout) and every handler stays in ManualBuilderMulti; this
// component receives them as props and owns no state.
//
// Phase 11B replaced the four Material Symbols ligatures with inline SVG on the
// same 16x16 grid the rest of the builder chrome already draws on. Duplicate and
// delete reuse the shared `DuplicatePath` / `TrashPath` glyphs verbatim; the two
// move arrows are local to this toolbar. Labels, titles, gates and targets are
// untouched.
function MoveUpPath() {
  return <path d="M8 12.5v-9M4 7.5 8 3.5l4 4" />;
}

function MoveDownPath() {
  return <path d="M8 3.5v9M4 8.5l4 4 4-4" />;
}

function EditModeToolbarButton({
  onClick,
  disabled,
  label,
  title,
  icon,
  tone = "neutral",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        "lz-builder-edit-toolbar__button",
        tone === "danger" ? "lz-builder-edit-toolbar__button--danger" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={label}
      title={title}
    >
      <svg viewBox="0 0 16 16" aria-hidden="true">
        {icon}
      </svg>
    </button>
  );
}

export default function EditModeToolbar({
  label,
  onMovePrevious,
  movePreviousDisabled,
  onMoveNext,
  moveNextDisabled,
  onDuplicate,
  duplicateDisabled,
  onDelete,
  deleteDisabled,
  movePreviousLabel = "Move workout to previous day",
  movePreviousTitle = "Move to previous day",
  moveNextLabel = "Move workout to next day",
  moveNextTitle = "Move to next day",
  duplicateLabel = "Duplicate workout in this week",
  duplicateTitle = "Duplicate",
  deleteLabel = "Delete workout from this week",
  deleteTitle = "Delete",
}) {
  return (
    <div className="lz-builder-edit-toolbar">
      <span className="lz-builder-edit-toolbar__label">{label}</span>
      <div className="lz-builder-edit-toolbar__actions">
        <EditModeToolbarButton
          onClick={onMovePrevious}
          disabled={movePreviousDisabled}
          label={movePreviousLabel}
          title={movePreviousTitle}
          icon={<MoveUpPath />}
        />
        <EditModeToolbarButton
          onClick={onMoveNext}
          disabled={moveNextDisabled}
          label={moveNextLabel}
          title={moveNextTitle}
          icon={<MoveDownPath />}
        />
        <EditModeToolbarButton
          onClick={onDuplicate}
          disabled={duplicateDisabled}
          label={duplicateLabel}
          title={duplicateTitle}
          icon={<DuplicatePath />}
        />
        <EditModeToolbarButton
          onClick={onDelete}
          disabled={deleteDisabled}
          label={deleteLabel}
          title={deleteTitle}
          icon={<TrashPath />}
          tone="danger"
        />
      </div>
    </div>
  );
}
